// DEPENDENCIES
import React, { useState } from 'react';
import { useFormik } from 'formik';

// CUSTOM COMPONENTS
import LoadingScreen from '../components/LoadingScreen';
import FormBlock from '../components/FormBlock';
import Section from '../components/Section';
import ContentBlock from '../components/ContentBlock';
import CustomBlock from '../components/CustomBlock';
import ContentHeader from '../components/ContentHeader';
import TextHeader from '../components/TextHeader';
import InputBlock from '../components/InputBlock';
import Button from '../components/Button';
import LogoBlock from '../components/LogoBlock';
import UserLoginValidator from '../helpers/validators/User/UserLoginValidator';

// ASSETS
import { ForgotPassword } from '../services/user.service';
import { Alert } from '../helpers/Alert';

const ForgotPasswordPage = (props) => {
    const ForgotPasswordSubmit = (values, setSubmitting) => {
        setLoading(true);
        ForgotPassword(values.username).then(res => {
            setSubmitting(false);
            setLoading(false);
            Alert({ success: true, message: "Email sent for password reset" });
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        })
    }

    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: { username: "" },
        onSubmit: (values, { setSubmitting }) => {
            ForgotPasswordSubmit(values, setSubmitting);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock
                        className="white--bg"
                        style={{ height: '100vh' }}
                    >
                        <LogoBlock />
                        <Section
                            rowClassName=""
                        >
                            <ContentBlock>
                                <FormBlock className="login-form-block" onSubmit={formik.handleSubmit}>
                                    <CustomBlock className="login-form-items">
                                        <TextHeader
                                            title="Forgot Password"
                                            headerSize="lg"
                                            centered
                                            className="darker-blue--clr"
                                        />
                                        <InputBlock
                                            id="username"
                                            inputLabel="Username"
                                            {...formik.getFieldProps("username")}
                                        />
                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                to="/"
                                                text="Cancel"
                                                className="danger--bg"
                                                disabled={formik.isSubmitting}
                                            />
                                            <Button
                                                text="Reset"
                                                type="submit"
                                                className="primary--bg"
                                                disabled={formik.isSubmitting}
                                            />
                                        </CustomBlock>
                                    </CustomBlock>
                                </FormBlock>
                            </ContentBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    )
}

export default ForgotPasswordPage;